<template>
  <div class="__PreferencesDialogExport">
    <CSection>
      <CRow gutter="md">
        <CCol col="12" sm="6">
          <CSelector
            :label="$t('Data type')"
            v-model="currentDataType"
            :options="dataTypeOptions"
            :use-input="false"
            emit-value
            map-options
          />
        </CCol>

        <CCol col="12" sm="6">
          <CSelector
            :label="$t('Image type')"
            v-model="currentImageType"
            :options="imageTypeOptions"
            :use-input="false"
            emit-value
            map-options
          />
        </CCol>
      </CRow>
    </CSection>

    <CSection>
      <CRow gutter="md">
        <CCol col="12" sm="6">
          <CInput
            name="currentPrefix"
            :label="$t('Prefix')"
            v-model="currentPrefix"
            :max-length="32"
            :min-length="0"
          />
        </CCol>
      </CRow>
    </CSection>
  </div>
</template>

<script>
import Vue from 'vue';

// Chart common lang
import chartLang from '@/components/CustomCharts/lang';

import CRow from '@/components/uikit/CRow';
import CCol from '@/components/uikit/CCol';
import CSection from '@/components/uikit/CSection';
import CSelector from '@/components/uikit/CSelector';
import CInput from '@/components/uikit/CInput';

const messages = {
  en: {
    // Chart common lang
    ...chartLang.en,

    'Data type': 'Data type',
    'Image type': 'Image type',
    Prefix: 'Prefix',
  },
  ja: {
    // Chart common lang
    ...chartLang.ja,

    'Data type': 'データの種類',
    'Image type': 'イメージの種類',
    Prefix: 'プリフィックス',
  },
};

export default Vue.extend({
  name: 'PreferencesDialogExport',
  i18n: { messages },
  components: {
    CRow,
    CCol,
    CSection,
    CSelector,
    CInput,
  },
  props: {
    dataType: {
      type: String,
      required: true,
    },
    imageType: {
      type: String,
      required: true,
    },
    prefix: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dataTypeOptions: [
        { label: this.$t('CSV'), value: 'csv' },
        { label: this.$t('XLSX'), value: 'xlsx' },
        { label: this.$t('JSON'), value: 'json' },
        { label: this.$t('HTML'), value: 'html' },
      ],

      imageTypeOptions: [
        { label: this.$t('PNG'), value: 'png' },
        { label: this.$t('JPG'), value: 'jpg' },
        { label: this.$t('SVG'), value: 'svg' },
        { label: this.$t('PDF'), value: 'pdf' },
      ],
    };
  },
  computed: {
    currentDataType: {
      get() {
        return this.dataType;
      },
      set(val) {
        this.$emit('update:dataType', val);
      },
    },
    currentImageType: {
      get() {
        return this.imageType;
      },
      set(val) {
        this.$emit('update:imageType', val);
      },
    },

    currentPrefix: {
      get() {
        return this.prefix;
      },
      set(val) {
        this.$emit('update:prefix', val);
      },
    },
  },
});
</script>
